import { useMemo } from "react";
import { Slider } from "@/components/ui/slider";

export const sensitivityToThreshold = (s) => 0.005 + (1 - s / 100) * 0.095;

export const SensitivityControl = ({ value, onChange, level, className = "", variant = "desktop" }) => {
  const marker = Math.min(1, sensitivityToThreshold(value) * 12) * 100;
  const sliderValue = useMemo(() => [value], [value]);
  return (
    <div className={`space-y-2 ${className}`} data-testid={`mic-sensitivity-control-${variant}`}>
      <div className="flex items-center justify-between">
        <span className="mono-label !text-[10px]">Mic sensitivity</span>
        <span className="font-mono text-[11px] tabular-nums text-[color:var(--au-green)]" data-testid={`mic-sensitivity-value-${variant}`}>{value}%</span>
      </div>
      <Slider value={sliderValue} min={0} max={100} step={1} onValueChange={(v) => onChange(v[0])} data-testid={`mic-sensitivity-slider-${variant}`} />
      <div className="relative h-1.5 bg-muted" data-testid={`mic-level-meter-${variant}`} title="Live mic level vs trigger threshold">
        <div className="h-full bg-[color:var(--au-green)] transition-[width] duration-100" style={{ width: `${Math.min(100, level * 100)}%` }} />
        <span className="absolute -top-1 h-3.5 w-0.5 bg-[color:var(--au-red)]" style={{ left: `${marker}%` }} />
      </div>
      <p className="font-mono text-[10px] text-muted-foreground">Lower it in noisy rooms. Speech must pass the red marker.</p>
    </div>
  );
};
